import { type FieldReadFunction } from '@apollo/client';

export const readProductStrengthDisplayText: FieldReadFunction = (
    _,
    { readField }
) => {
    const strengthText = readField<string>('strengthText');
    const strengthUnit = readField<string>('strengthUnit');

    if (!!strengthText && !!strengthUnit) {
        return `${strengthText}${strengthUnit}`;
    }
    return null;
};
